<template>
    <div class="my-quotation">
        <!-- Gradient Mesh Hero -->
        <div class="mesh-hero">
            <h3 class="hero-title">GEO大模型搜索优化在线询价</h3>
        </div>

        <div class="quotation-content" v-if="!showForm">
            <!-- Form Card -->
            <div class="form-card">
                <van-cell @click="showCategory = true" title="选择行业" :value="categoryDesc || '请选择行业'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <template v-if="!provinceSingle">
                    <van-cell @click="showProvince = true" title="投放省份" :value="provinceDesc || '请选择投省份'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                    <van-cell v-show="mathParams.provinceList.length == 1 && showProvinceCityList.length != 1" @click="loadProvinceCityList" title="投放城市" :value="cityDesc || '请选择投放城市'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                </template>
                <van-cell v-else @click="showCity = true" title="投放城市" :value="allCityDesc || '请选择投放城市'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <van-cell @click="showWordCount = true" title="词根数量" :value="mathParams.wordCount || '请选择词根数量'" :class="{ 'red-cell': mathParams.wordCount }" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <van-cell @click="showDuration = true" title="服务时长" :value="mathParams.duration || '请选择服务时长'" :class="{ 'red-cell': mathParams.duration }" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <div class="word-input-wrapper" v-if="showWords">
                    <van-field v-model="mathParams.words" id="wordInput" type="textarea" label="词根查询" placeholder="请输入词根，多个词根以逗号或回车分隔；如无需查询，可不填。" rows="3" autosize :border="false" class="word-input-field" />
                </div>
            </div>

            <!-- 行业提示 -->
            <div class="hint-line" v-if="industryLavel === '暂时不开发'">
                <div class="hint-line__icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <circle cx="8" cy="8" r="6.5" stroke="#ea2261" stroke-width="1.2"/>
                        <path d="M5.5 5.5l5 5" stroke="#ea2261" stroke-width="1.2" stroke-linecap="round"/>
                    </svg>
                </div>
                <span class="hint-text">该行业暂不提供服务，请咨询服务商  </span>
            </div>
            <div class="region-note" v-else-if="industryDefaultRegion && industryDefaultRegion !== '全国'">
                <div class="region-note__icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 1.5C5.5 1.5 3.5 3.5 3.5 6c0 3.5 4.5 8.5 4.5 8.5s4.5-5 4.5-8.5c0-2.5-2-4.5-4.5-4.5Z" stroke="#533afd" stroke-width="1.2" fill="none"/>
                        <circle cx="8" cy="6" r="1.5" stroke="#533afd" stroke-width="1" fill="none"/>
                    </svg>
                </div>
                <span class="region-note__text">该行业更适合 <strong>{{ industryDefaultRegion }}</strong> 推广  </span>
            </div>

            <!-- 查询按钮 -->
            <div class="button-group">
                <button class="btn-primary-pill" @click="submitMathPrice">查询报价</button>
            </div>

            <!-- 询价错误 -->
            <div class="error-bar" v-if="mathError">
                <div class="error-bar__badge">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8 1.5L14.5 13H1.5L8 1.5Z" stroke="#d1456a" stroke-width="1.2" stroke-linejoin="round" fill="none"/>
                        <path d="M8 6v3.5" stroke="#d1456a" stroke-width="1.2" stroke-linecap="round"/>
                        <circle cx="8" cy="11.5" r="0.6" fill="#d1456a"/>
                    </svg>
                </div>
                <span class="error-bar__text">{{ mathError }}</span>
            </div>

            <!-- 询价结果 -->
            <div class="result-card" v-else-if="mathResult.price" @click="handleCreateSharePage" :class="{ 'result-card--loading': shareLoading, 'result-card--limited': mathResult.limitPrice }">
                <div class="result-label-row">
                    <span class="result-label">询价结果</span>
                    <span class="result-tag" v-if="mathResult.usePriceType == specialOfferPriceType">{{ mathResult.specialOfferTypeTitle || "直通车" }}</span>
                    <span class="result-tag" v-else-if="mathResult.usePriceType == activityPriceType">{{ mathResult.activityTitle || "活动优惠" }}</span>
                </div>
                <div class="result-price-row">
                    <template v-if="mathResult.showPrice">
                        <span class="result-original">￥{{ mathResult.price }}</span>
                    </template>
                    <span class="result-final">￥{{ mathResult.payPrice }}</span>
                </div>
                <div class="result-footer">
                    <span class="result-footer-link" v-if="!mathResult.limitPrice">
                        <span class="result-footer-text">{{ shareLoading ? '生成中...' : '生成完整报价单' }}</span>
                        <span class="result-footer-arrow">→</span>
                    </span>
                    <span class="result-footer-tip" v-else>
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <path d="M8 1.5L14.5 13H1.5L8 1.5Z" stroke="#a8193e" stroke-width="1.2" stroke-linejoin="round" fill="none"/>
                            <path d="M8 6v3.5" stroke="#a8193e" stroke-width="1.2" stroke-linecap="round"/>
                            <circle cx="8" cy="11.5" r="0.6" fill="#a8193e"/>
                        </svg>
                        <span class="result-footer-tip__text">{{ mathResult.limitTip || '是否能全国展现请咨询服务商' }}</span>
                    </span>
                </div>
            </div>
        </div>
        <van-popup v-model="showCategory" position="bottom" round :style="{ height: '60%' }">
            <!-- :loading="showCategoryLoading" -->
            <van-picker ref="categoryPicker" title="选择行业" show-toolbar :columns="showCategoryList" @change="changeCategory" @confirm="confirmCategory" @cancel="showCategory = false">
                <template #columns-top>
                    <div class="category-search-box">
                        <van-field v-model="categoryKeyword" placeholder="输入行业关键字" clearable @input="onCategoryKeywordInput" left-icon="search" />
                    </div>
                </template>
            </van-picker>
        </van-popup>
        <!-- 下面是城市多选 -->
        <my-select :show.sync="showProvince" title="投放省份" :list="config.provinceList" :value="mathParams.provinceList" @change="changetProvince" @close="confirmProvince" />
        <my-select :show.sync="showProvinceCity" title="投放城市" :list="showProvinceCityList" :value="mathParams.cityList" @change="changetProvinceCity" />
        <!-- 下面是城市选单 -->
        <van-popup v-model="showCity" position="bottom" round :style="{ height: '60%' }">
            <van-picker ref="cityPicker" title="投放城市" show-toolbar :columns="showCityList" @change="changeCity" @confirm="confirmCity" @cancel="showCity = false">
                <template #columns-top>
                    <div class="category-search-box">
                        <van-field v-model="cityKeyword" placeholder="输入城市关键字" clearable @input="onCityKeywordInput" left-icon="search" />
                    </div>
                </template>
            </van-picker>
        </van-popup>
        <van-popup v-model="showWordCount" position="bottom" round>
            <van-picker show-toolbar title="词根数量" :columns="showWordCountList" @confirm="confirmWordCount" @cancel="showWordCount = false" />
        </van-popup>
        <van-popup v-model="showDuration" position="bottom" round>
            <van-picker show-toolbar title="服务时长" :columns="showDurationList" @confirm="confirmDuration" @cancel="showDuration = false" />
        </van-popup>

        <van-dialog v-model="showForm" :before-close="beforeCloseInputPhoneDialog" title="请输入询价校验码" style="padding: 0 12px" theme="round-button">
            <div class="logo-img">
                <!-- <img src="/static/img/logo.png" width="200px" height="200px" /> -->
                <div style="padding-top: 150px">
                    <span class="logo-title">GEO大模型搜索优化在线询价</span>
                </div>
            </div>
            <van-field ref="codeField" v-model="code" placeholder="请输入校验码，点击确认后查看询价" />
        </van-dialog>

        <!-- 词根饱和度查询弹框 -->
        <word-saturation-popup
            :show.sync="showWordStatPopup"
            :word-list="currentWords"
            :category="mathParams.category"
            :sub-category="mathParams.subCategory"
            :province="mathParams.provinceList.length > 0 ? mathParams.provinceList[0] : ''"
            :city="mathParams.cityList.length > 0 ? mathParams.cityList[0] : ''"
            @continue="handleContinueMathPrice"
            @update-words="handleUpdateWords"
        />

        <van-overlay :show="!loadReady">
            <van-loading type="spinner" color="#1989fa" />
        </van-overlay>
    </div>
</template>

<script>
import { getBrowserKeyAsync } from "@/utils/browserUtil";
import { verifyCode, getConfigInfo, mathPriceInfo, getCityList, getSubCategoryList, searchCategoryIncludeSubCategory, searchProvinceIncludeCity, specialOfferPriceType, activityPriceType, initQuotationConfig, createQuotationShare, getIndustryInfo } from "@/api/quotation";
import MySelect from "@/components/mySelect";
import WordSaturationPopup from "@/components/WordSaturationPopup";
const allProvinceLabel = "全国";
const allCityLabel = "所有地区";
const wordCountOne = "=1";
const wordCountOneDurationList = ["3个月"];
//省份单选还是多选
const provinceSingle = true;
export default {
    name: "Quotation",
    components: {
        [MySelect.name]: MySelect,
        [WordSaturationPopup.name]: WordSaturationPopup,
    },
    data() {
        return {
            loadReady: false,
            showForm: false,
            code: "",
            config: {
                provinceList: [],
                cityList: [],
                categoryList: [],
                subCategoryList: [],
                wordCountList: [],
                durationList: [],
            },
            showProvince: false,
            showProvinceCity: false,
            showProvinceCityList: [],
            categoryKeyword: '',
            cityKeyword: '',
            showCategoryList: [],
            showCityList: [],
            ////加载过快会闪屏，所以去掉
            //showCategoryLoading: false,
            //showCityLoading: false,
            showCategory: false,
            showCity: false,
            showWordCount: false,
            showDuration: false,
            //询价参数
            mathParams: {
                code: "",
                provinceList: [],
                cityList: [],
                category: "",
                subCategory: "",
                wordCount: "",
                duration: "",
                words: "",
            },
            //询价结果
            mathResult: {
                price: "",
                payPrice: "暂无报价",
                activityTitle: "9月活动特惠",
                usePriceType: 0,
                showPrice: false,
                specialOfferTypeTitle: "",
                limitPrice: false,
                limitTip: "",
            },
            // 词根饱和度查询弹框
            showWordStatPopup: false,
            currentWords: [],
            // 询价错误信息
            mathError: "",
            // 行业默认投放区域
            industryDefaultRegion: "",
            // 行业级别（-1暂时不开发）
            industryLavel: "",
            shareLoading: false,
            specialOfferPriceType,
            activityPriceType,
            wordCountOne,
            wordCountOneDurationList,
            provinceSingle,
            // 是否显示询价词根
            //// 以前是测试才显示
            //document.domain.includes("test"),
            showWords: true,
        };
    },
    computed: {
        //计算属性
        categoryDesc() {
            if (!this.mathParams.category) {
                return "";
            }
            return this.mathParams.category + (this.mathParams.subCategory ? " - " + this.mathParams.subCategory : "");
        },
        provinceDesc() {
            return this.mathParams.provinceList.join(",");
        },
        cityDesc() {
            return this.mathParams.cityList.join(",");
        },
        allCityDesc() {
            let plist = this.mathParams.provinceList;
            if (!(plist && plist.length > 0)) {
                return "";
            }
            return this.provinceDesc + "-" + this.cityDesc;
        },
        showDurationList() {
            if (this.mathParams.wordCount == wordCountOne) {
                return wordCountOneDurationList;
            }
            // 默认时长列表（排除 =1 词根专用时长）
            const baseList = this.config.durationList.filter((item) => !wordCountOneDurationList.includes(item));
            // 命中行业添加服务时长配置：额外放行配置时长并放最前（添加的时长即为默认被排除的时长，如 3个月）
            const addDurationConfig = (this.config.addDurationIndustryList || []).find((cfg) => (cfg.industryList || []).includes(this.mathParams.category));
            if (addDurationConfig && addDurationConfig.durationList && addDurationConfig.durationList.length > 0) {
                const addDurations = addDurationConfig.durationList.filter((item) => !baseList.includes(item));
                return [...addDurations, ...baseList];
            }
            return baseList;
        },
        // 词根数量列表（命中行业限制字根数配置的行业过滤对应词根）
        showWordCountList() {
            const limitWordCountConfig = (this.config.limitIndustryWordCountList || []).find((cfg) => (cfg.industryList || []).includes(this.mathParams.category));
            if (limitWordCountConfig && limitWordCountConfig.wordCount) {
                return (this.config.wordCountList || []).filter((item) => item !== limitWordCountConfig.wordCount);
            }
            return this.config.wordCountList;
        },
        // 用于监听需要触发重置的参数字段（排除words）
        mathParamsKey() {
            var p = this.mathParams;
            return [p.category, p.subCategory, p.provinceList.join(","), p.cityList.join(","), p.wordCount, p.duration].join("|");
        },
    },
    created() {
        this.init();
        this.addEnterEvent(this.handleSubmit.bind(this), "inputCodeSubmit");
        document.querySelector("body").setAttribute("style", "background-color:#f6f9fc");
        window.qtn = this;
        //this.mathParams = {"code":"6751","provinceList":["全国"],"cityList":["所有地区"],"category":"农林牧渔","subCategory":"农业","wordCount":"≤5","duration":"6个月","words":"纪念币回收,邮票回收,变压器回收,金银币回收,钱币回收,银元回收"};
    },
    watch: {
        // 监听询价参数变动（排除words），重置结果与错误
        mathParamsKey() {
            this.resetMathResult();
        },
    },
    mounted() {
        //组件加载
    },
    destroyed() {
        //组件释放
        this.delEnterEvent("inputCodeSubmit");
    },
    beforeRouteLeave(to, from, next) {
        // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
        // next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
        // next(false): 中断当前的导航。如果浏览器的 URL 改变了（可能是用户手动或者浏览器后退按钮），那么 URL 地址会重置到 from 路由对应的地址。
        // next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。
        // next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例，则导航会被终止且该错误会被传递给 router.onError() 注册过的回调。
        // 确保要调用 next 方法，否则钩子就不会被 resolved。

        //return next() // 下一步
        //return Promise.reject(true).delay(2000).then(()=>next(),()=>next(false));
        //return Promise.resolve(true).delay(2000).then(()=>next(),()=>next(false));
        //console.log("后退……");
        return this.callBackEvent().then(
            () => next(),
            (e) => next(false)
        );
    },
    methods: {
        //初始化数据
        init() {
            //更换地址栏图标
            this.changeFavicon("/static/img/quotation.ico");

            // 初始化询价配置（从后端加载禁用词等配置）
            initQuotationConfig().catch(err => {
                this.$msg.error("获取询价配置信息失败");
            });

            var that = this,
                code = (that.code = this.$route.query.code || "");
            if (code) {
                that.setLoad(() => {
                    return getBrowserKeyAsync().then(that.initConfigInfo);
                }).catch(that.showInputPhoneDialog);
            } else {
                that.loadReady = true;
                that.showInputPhoneDialog();
            }
        },
        //初始化询价信息
        initConfigInfo() {
            var that = this,
                code = that.code;
            if (!code) {
                return Promise.reject("请输入有效的校验码");
            }
            return getConfigInfo(that.code)
                .then((res) => {
                    var configObj = res?.data || {};
                    that.$set(that, "config", configObj);
                    that.mathParams.code = that.code;
                    that.showCategoryList.splice(0);
                    that.showCityList.splice(0);
                    (configObj.categoryList || []).forEach((p, pi) => {
                        let obj = {
                            text: p,
                            children: [{ text: "" }],
                        };
                        if (pi === 0) {
                            obj.children = (configObj.subCategoryList || []).map((c) => ({ text: c }));
                        }
                        that.showCategoryList.push(obj);
                    });
                    (configObj.provinceList || []).forEach((p, pi) => {
                        let obj = {
                            text: p,
                            children: [{ text: allCityLabel }],
                            load: false,
                        };
                        if (pi === 0) {
                            obj.children = (configObj.cityList || []).map((c) => ({ text: c }));
                            obj.load = true;
                        }
                        that.showCityList.push(obj);
                    });
                    if (that.showCityList && that.showCityList.length == 1) {
                        this.mathParams.provinceList.splice(0);
                        this.mathParams.provinceList.push(that.showCityList[0].text);
                        this.setShowProvinceCityList().then((list) => {
                            if (list.length == 0) {
                                return;
                            }
                            if (list.length == 1) {
                                this.mathParams.cityList.splice(0);
                                this.mathParams.cityList.push(list[0]);
                                return;
                            }
                            if (provinceSingle) {
                                this.mathParams.cityList.splice(0);
                                this.mathParams.cityList.push(list.includes(allCityLabel) ? allCityLabel : list[0]);
                            }
                        });
                    }
                })
                .catch((e) => {
                    that.$msg.error(e || "获取询价配置信息失败");
                    return Promise.reject(e);
                });
        },
        //回车提交输入校检码
        handleSubmit(e) {
            if (this.showForm) {
                if (!this.code) {
                    return this.$msg.error("请输入有效的校验码");
                }
                return this.beforeCloseInputPhoneDialog("confirm", () => {});
            } else {
                var that = this;
                if (e && e.target && e.target.id == "wordInput") {
                    //如果是词根输入框，不处理回车
                    return;
                }
                if (!that.mathParams.code) {
                    return that.$msg.error("请输入有效的校验码");
                }
                // 如果有任何弹框正在显示，则不执行价格计算
                if (that.showCategory || that.showProvince || that.showProvinceCity || that.showCity || that.showWordCount || that.showDuration || that.showWordStatPopup) {
                    return;
                }
                return that.submitMathPrice();
            }
        },
        //关闭输入校验码弹框
        beforeCloseInputPhoneDialog(action, done) {
            //console.log(action);
            if (action === "confirm") {
                this.code = (this.code || "").trim();
                if (!this.code) {
                    this.$msg("请输入有效的校验码");
                    done(false);
                } else {
                    this.initConfigInfo().then(
                        () => {
                            //console.log("initConfigInfo");
                            this.showForm = false;
                            done();
                        },
                        (e) => {
                            console.log("initConfigInfo", e);
                            done(false);
                        }
                    );
                }
            } else {
                done(false);
            }
        },
        //显示弹框输入校验码
        showInputPhoneDialog() {
            this.showForm = true;
            this.$nextTick(() => {
                this.$refs.codeField.focus();
                setTimeout(() => {
                    this.$refs.codeField.focus();
                }, 3000);
            });
        },

        //选择行业
        changeCategory(picker, valList, index) {
            if (picker.getColumnIndex(0) > 0 && picker.getColumnValues(1).length == 1) {
                var that = this,
                    category = valList[0],
                    firstColumnIndex = picker.getColumnIndex(0);
                that.loadSubCategory(category, firstColumnIndex, picker);
            }
        },
        // 加载二级分类（复用方法）
        loadSubCategory(category, firstColumnIndex, picker) {
            var that = this;
            return getSubCategoryList(that.code, category)
                .then((res) => {
                    var list = ((res || {}).data || []).map((text) => ({ text }));
                    if (list.length > 0) {
                        that.showCategoryList[firstColumnIndex].children.splice(0);
                        list.forEach((item) => that.showCategoryList[firstColumnIndex].children.push(item));
                        if (picker && (picker.getColumnValue(0) || {}).text == category) {
                            picker.setColumnValues(1, list);
                        }
                        return list;
                    } else {
                        return Promise.reject("获取子行业失败");
                    }
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取子行业失败");
                    that.showCategory = false;
                    return [];
                });
        },
        // 行业关键字搜索
        onCategoryKeywordInput(keyword) {
            if (!keyword || !keyword.trim()) return;
            var that = this;
            //console.log(keyword);
            //that.throttleCall 是节流函数
            that.throttleCall('searchCategoryIncludeSubCategory',()=>{
                searchCategoryIncludeSubCategory(that.code, keyword.trim()).then((res) => {
                    var categoryList = (res || {}).data || [];
                    if (!categoryList.length) return;
                    var firstCategory = categoryList[0];
                    var picker = that.$refs.categoryPicker;
                    if (!picker) return;
                    // 找到一级分类对应的索引
                    var colIndex = that.showCategoryList.findIndex((item) => item.text === firstCategory);
                    if (colIndex < 0) return;
                    // 选中一级分类
                    picker.setColumnIndex(0, colIndex);
                    // 加载二级分类
                    that.loadSubCategory(firstCategory, colIndex, picker).then((subList) => {
                        if (!subList || !subList.length) return;
                        // 查找二级分类中是否有包含关键字的项
                        var matchIndex = subList.findIndex((item) => item.text && item.text.includes(keyword.trim()));
                        if (matchIndex >= 0) {
                            picker.setColumnIndex(1, matchIndex);
                        } else {
                            picker.setColumnIndex(1, 0);
                        }
                    });
                });
            },500,0);
        },
        confirmCategory(valList, indexList) {
            if (valList && valList.length == 2 && valList[0] && valList[1]) {
                this.mathParams.category = valList[0];
                this.mathParams.subCategory = valList[1];
                // 切换行业后：词根/时长不在当前行业可选列表时同步清空（行业限制字根数、添加服务时长配置驱动）
                if (!this.showWordCountList.includes(this.mathParams.wordCount)) {
                    this.mathParams.wordCount = "";
                }
                if (!this.showDurationList.includes(this.mathParams.duration)) {
                    this.mathParams.duration = "";
                }
                // 异步获取行业信息
                this.industryDefaultRegion = "";
                this.industryLavel = "";
                getIndustryInfo(this.code, valList[0], valList[1]).then((res) => {
                    var industry = res?.data || {};
                    this.industryLavel = industry.lavel || "";
                    var extraObj = industry.extraObj || {};
                    this.industryDefaultRegion = extraObj.defaultRegion || "";
                }).catch(() => {
                    this.industryDefaultRegion = "";
                    this.industryLavel = "";
                });
            }
            this.showCategory = false;
        },
        //选择城市
        ////单选择城市
        changeCity(picker, valList, index) {
            if (picker.getColumnIndex(0) > 0 && picker.getColumnValues(1).length == 1) {
                var that = this,
                    province = valList[0];
                that.loadCityForPicker(province, picker);
            }
        },
        // 加载城市列表到picker（复用方法）
        loadCityForPicker(province, picker) {
            var that = this;
            return that.getProvinceCityList(province)
                .then((cityTextList) => {
                    var list = cityTextList.map((text) => (typeof text === 'string' ? { text } : text));
                    if (picker && (picker.getColumnValue(0) || {}).text == province) {
                        picker.setColumnValues(1, list);
                    }
                    return cityTextList;
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取市区失败");
                    that.showCity = false;
                    return [];
                });
        },
        // 城市关键字搜索
        onCityKeywordInput(keyword) {
            if (!keyword || !keyword.trim()) return;
            var that = this;
            that.throttleCall('searchProvinceIncludeCity', () => {
                searchProvinceIncludeCity(that.code, keyword.trim()).then((res) => {
                    var provinceList = (res || {}).data || [];
                    if (!provinceList.length) return;
                    var firstProvince = provinceList[0];
                    var picker = that.$refs.cityPicker;
                    if (!picker) return;
                    // 找到省份对应的索引
                    var colIndex = that.showCityList.findIndex((item) => item.text === firstProvince);
                    if (colIndex < 0) return;
                    // 选中省份
                    picker.setColumnIndex(0, colIndex);
                    // 加载城市列表
                    that.loadCityForPicker(firstProvince, picker).then((cityList) => {
                        if (!cityList || !cityList.length) return;
                        // 查找城市中是否有包含关键字的项
                        var matchIndex = cityList.findIndex((item) => {
                            var text = typeof item === 'string' ? item : item.text;
                            return text && text.includes(keyword.trim());
                        });
                        if (matchIndex >= 0) {
                            picker.setColumnIndex(1, matchIndex);
                        } else {
                            picker.setColumnIndex(1, 0);
                        }
                    });
                });
            }, 500, 0);
        },
        confirmCity(valList, indexList) {
            //console.log(valList, indexList);
            if (valList && valList.length == 2 && valList[0] && valList[1]) {
                this.mathParams.provinceList.splice(0, this.mathParams.provinceList.length, valList[0]);
                this.mathParams.cityList.splice(0, this.mathParams.cityList.length, valList[1]);
            }
            this.showCity = false;
        },
        //多选城市
        //加载省份对应城市
        loadProvinceCityList() {
            var that = this;
            this.setShowProvinceCityList()
                .then(() => {
                    return (that.showProvinceCity = true);
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取市区失败");
                });
        },
        setShowProvinceCityList() {
            var len = this.mathParams.provinceList.length;
            if (len == 0) {
                return Promise.reject("请先选择省份");
            }
            var that = this;
            if (len > 1) {
                that.showProvinceCityList.splice(0);
                var defCityInfo = { text: allCityLabel };
                that.showProvinceCityList.push(defCityInfo);
                return Promise.resolve([defCityInfo]);
            }
            var province = that.mathParams.provinceList[0];
            return this.getProvinceCityList(province).then((list) => {
                if (that.mathParams.provinceList.length == 1 && that.mathParams.provinceList[0] == province) {
                    that.showProvinceCityList.splice(0);
                    that.showProvinceCityList.push(...list);
                }
                return list;
            });
        },
        getProvinceCityList(province) {
            var that = this,
                pi = that.showCityList.findIndex((item) => item.text == province);
            if (pi == -1) {
                return Promise.reject("请先选择省份");
            }
            var curProvince = that.showCityList[pi];
            if (curProvince.load && curProvince.children && curProvince.children.length > 0) {
                return Promise.resolve(curProvince.children.map((s) => s.text));
            }
            return that.loadGlobal("pl-" + province, () => {
                return getCityList(that.code, province).then((res) => {
                    var cityList = (res || {}).data || [],
                        list = cityList.map((text) => ({ text }));
                    if (list.length > 0) {
                        that.showCityList[pi].children.splice(0);
                        list.forEach((item) => that.showCityList[pi].children.push(item));
                        that.showCityList[pi].load = true;
                        return list;
                    } else {
                        return Promise.reject("获取市区失败");
                    }
                });
            });
        },
        //选择省份时
        changetProvince(checked, provinceList, province) {
            if (checked) {
                if (province == allProvinceLabel && provinceList.length > 1) {
                    this.mathParams.provinceList.splice(0, this.mathParams.provinceList.length - 1);
                } else if (province != allProvinceLabel && provinceList[0] == allProvinceLabel) {
                    this.mathParams.provinceList.splice(0, 1);
                }
            }
            if (this.mathParams.provinceList.length > 1) {
                this.mathParams.cityList.splice(0);
                this.mathParams.cityList.push(allCityLabel);
            } else {
                this.mathParams.cityList.splice(0);
            }
            if (checked && province) {
                this.getProvinceCityList(province).catch(console.error);
            }
        },
        confirmProvince() {
            if (this.mathParams.provinceList.length == 1) {
                var that = this;
                that.setShowProvinceCityList().then(() => {
                    var list = that.showProvinceCityList;
                    if (list.length == 1) {
                        that.mathParams.cityList.splice(0);
                        that.mathParams.cityList.push(list[0]);
                    }
                });
            }
        },
        //选择城市时
        changetProvinceCity(checked, cityList, city) {
            if (checked) {
                if (city == allCityLabel && cityList.length > 1) {
                    this.mathParams.cityList.splice(0, this.mathParams.cityList.length - 1);
                } else if (city != allCityLabel && cityList[0] == allCityLabel) {
                    this.mathParams.cityList.splice(0, 1);
                }
            }
        },
        //选择词根数
        confirmWordCount(wordCount) {
            this.mathParams.wordCount = wordCount;
            this.showWordCount = false;
            if (!this.showDurationList.includes(this.mathParams.duration)) {
                this.mathParams.duration = "";
            }
            if (this.mathParams.wordCount == wordCountOne) {
                if (wordCountOneDurationList.length == 1) {
                    this.mathParams.duration = wordCountOneDurationList[0];
                }
            } else {
            }
        },
        //选择服务时长
        confirmDuration(duration) {
            this.mathParams.duration = duration;
            this.showDuration = false;
        },

        //查询报价
        submitMathPrice() {
            var that = this;
            if (!that.mathParams.code) {
                return that.$msg.error("请输入有效的校验码");
            }
            if (!that.mathParams.category) {
                return that.$msg.error("请选择服务行业");
            }
            if (!that.mathParams.subCategory) {
                return that.$msg.error("请选择服务行业子类别");
            }
            if (!that.mathParams.provinceList.length) {
                return that.$msg.error("请选择投放省份");
            }
            if (!that.mathParams.cityList.length) {
                return that.$msg.error("请选择投放城市");
            }
            if (!that.mathParams.wordCount) {
                return that.$msg.error("请选择词根数量");
            }
            if (!that.mathParams.duration) {
                return that.$msg.error("请选择服务时长");
            }
            // 行业限制字根数配置命中：所选词根被限制则无报价（前端兜底，后端同样拦截）
            var limitWordCountConfig = (that.config.limitIndustryWordCountList || []).find((cfg) => (cfg.industryList || []).includes(that.mathParams.category));
            if (limitWordCountConfig && limitWordCountConfig.wordCount == that.mathParams.wordCount) {
                return that.$msg.error("暂无报价，请咨询服务商");
            }
            //词根数组
            var words = (that.mathParams.words || "")
                .replace(/[,，;； \-\\、\n]/g, "\t")
                .split(/\t/)
                .map((word) => word.trim())
                .filter((word) => word);
            // 如果词根为空,跳过饱和度查询,直接询价
            if (!words || !words.length) {
                return that.handleContinueMathPrice();
            }
            // 显示词根饱和度查询弹框
            that.currentWords = words;
            that.showWordStatPopup = true;
        },

        // 继续询价
        handleContinueMathPrice() {
            var that = this;
            // 清空之前的结果
            that.resetMathResult();
            // 查询报价
            mathPriceInfo(that.mathParams).then((res) => {
                var result = res?.data || {};
                if (!result.payPrice) {
                    var errorMsg = "暂无报价，请咨询服务商";
                    that.$msg.error(errorMsg);
                    that.mathError = errorMsg;
                    return;
                }
                that.$set(that, "mathResult", {
                    price: result.price || "",
                    payPrice: result.payPrice || "暂无报价",
                    showPrice: result.showPrice || false,
                    usePriceType: result.usePriceType || 0,
                    specialOfferTypeTitle: result.specialOfferTypeTitle || "",
                    activityTitle: result.activityTitle || "",
                    limitPrice: !!result.limitPrice,
                    limitTip: result.limitTip || "",
                });
            }, (e) => {
                var errorMsg = (e || "询价失败").toString().replace(/^Error:\s*/i, "");
                that.$msg.error(errorMsg);
                that.mathError = errorMsg;
            });
        },

        // 更新词根数组
        handleUpdateWords(words) {
            var that = this;
            // 以回车 Join 成字符串保存
            that.mathParams.words = words.join('\n');
        },

        // 重置询价结果与错误信息（已为空则跳过）
        resetMathResult() {
            if (!this.mathError && !this.mathResult.price && !this.mathResult.limitPrice) return;
            this.mathError = "";
            this.mathResult = {
                price: "",
                payPrice: "暂无报价",
                showPrice: false,
                usePriceType: 0,
                specialOfferTypeTitle: "",
                activityTitle: "",
                limitPrice: false,
                limitTip: "",
            };
        },

        // 创建询价分享页
        handleCreateSharePage() {
            var that = this;
            // 命中限制询价对象时不生成报价单
            if (that.mathResult.limitPrice) return;
            if (that.shareLoading) return;
            that.shareLoading = true;
            var postData = {
                code: that.mathParams.code,
                category: that.mathParams.category,
                subCategory: that.mathParams.subCategory,
                provinceList: that.mathParams.provinceList,
                cityList: that.mathParams.cityList,
                wordCount: that.mathParams.wordCount,
                duration: that.mathParams.duration,
                words: that.mathParams.words,
                price: that.mathResult.price,
                payPrice: that.mathResult.payPrice,
                showPrice: that.mathResult.showPrice,
                usePriceType: that.mathResult.usePriceType,
                specialOfferTypeTitle: that.mathResult.specialOfferTypeTitle,
                activityTitle: that.mathResult.activityTitle,
            };
            createQuotationShare(postData).then((res) => {
                var shareCode = res.data;
                if (shareCode) {
                    that.$router.push('/q/' + shareCode);
                } else {
                    that.$msg.error("生成分享页失败");
                }
            }, (e) => {
                that.$msg.error((e || "生成分享页失败").toString().replace(/^Error:\s*/i, ""));
            }).finally(() => {
                that.shareLoading = false;
            });
        },

        //设置加载动画
        setLoad(pe) {
            var that = this,
                nextPe = Promise.isPromise(pe) ? () => pe : pe;
            that.loadReady = false;
            if (!that.retPe) {
                that.retPe = Promise.resolve(true);
            }
            that.retPe = that.retPe
                .then(() => {
                    that.loadReady = false;
                })
                .then(nextPe)
                //.then(console.log)
                .finally(() => {
                    that.loadReady = true;
                });
            return that.retPe;
        },
    },
};
</script>

<style scoped>
/* ============================================================
   DESIGN TOKENS (Stripe-inspired — DESIGN.md)
   ============================================================ */
/*  Colors
    primary:       #533afd   ink:           #0d253d
    primary-deep:  #4434d4   ink-mute:      #64748d
    primary-press: #2e2b8c   canvas:        #ffffff
    ruby:          #ea2261   canvas-soft:   #f6f9fc
    on-primary:    #ffffff   hairline:      #e3e8ee
    brand-dark:    #1c1e54   hairline-input:#a8c3de
    shadow-blue:   rgba(0,55,112,0.08)
*/

/* ============================================================
   BASE
   ============================================================ */
.my-quotation {
    font-family: Inter, "SF Pro Display", system-ui, -apple-system, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: "ss01";
    color: #0d253d;
    background-color: #f6f9fc;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.4;
    padding: 0;
    margin: 0;
    width: 100%;
    min-height: 100dvh;
    position: relative;
}

/* ============================================================
   GRADIENT MESH HERO
   ============================================================ */
.mesh-hero {
    position: relative;
    padding: 48px 24px 56px;
    text-align: center;
    background: linear-gradient(135deg,
        #3a86ff 0%,
        #8338ec 25%,
        #c026d3 50%,
        #6366f1 75%,
        #3a86ff 100%
    );
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(99, 102, 241, 0.4), 0 4px 12px rgba(131, 56, 236, 0.25);
}

.mesh-hero::after {
    content: "";
    position: absolute;
    inset: 0;
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
}

.hero-title {
    position: relative;
    z-index: 1;
    margin: 0;
    font-size: 26px;
    font-weight: 300;
    line-height: 1.12;
    letter-spacing: -0.26px;
    color: #ffffff;
    text-shadow: 0 1px 8px rgba(0,0,0,0.15);
}

/* ============================================================
   CONTENT CONTAINER
   ============================================================ */
.quotation-content {
    position: relative;
    z-index: 1;
    padding: 16px;
    margin: -24px auto 0;
    max-width: 768px;
}

/* ============================================================
   FORM CARD
   ============================================================ */
.form-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
    box-shadow: rgba(0,55,112,0.08) 0 1px 3px;
    overflow: hidden;
}

/* ============================================================
   SELECT CELLS
   ============================================================ */
.my-quotation /deep/ .select-cell {
    border-bottom: 1px solid #e3e8ee;
}
.my-quotation /deep/ .select-cell:last-child {
    border-bottom: none;
}
.my-quotation /deep/ .select-cell .van-cell__title {
    font-weight: 400;
    font-size: 14px;
    color: #64748d;
    letter-spacing: -0.42px;
}
.my-quotation /deep/ .select-cell .van-cell__value {
    font-weight: 300;
    font-size: 15px;
    color: #0d253d;
    letter-spacing: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.my-quotation /deep/ .select-cell.red-cell .van-cell__value {
    color: #ea2261;
}

/* ============================================================
   WORD INPUT
   ============================================================ */
.word-input-wrapper {
    overflow: hidden;
    width: 100%;
    border-top: 1px solid #e3e8ee;
}

.word-input-field {
    background: #fff;
    width: 100%;
    margin: 0;
}

.word-input-field /deep/ .van-cell {
    padding: 12px 16px;
    width: 100%;
    box-sizing: border-box;
}

.word-input-field /deep/ .van-field__control {
    min-height: 72px;
    font-size: 14px;
    line-height: 24px;
}

.word-input-field /deep/ .van-field__label {
    width: 70px;
    color: #64748d;
    font-weight: 400;
    font-size: 14px;
}

/* ============================================================
   HINT LINE — 警告提示卡片（含动效）
   ============================================================ */
.hint-line {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 10px 16px;
    background: #fff4f6;
    border: 1px solid rgba(234, 34, 97, 0.12);
    border-radius: 12px;
    animation: hint-line-enter 0.4s cubic-bezier(0.32, 0.72, 0, 1) both;
}

@keyframes hint-line-enter {
    from {
        opacity: 0;
        transform: translateX(-12px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.hint-line__icon {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: rgba(234, 34, 97, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    animation: hint-icon-shake 3s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
}

@keyframes hint-icon-shake {
    0%, 100% { transform: rotate(0deg) scale(1); }
    8%       { transform: rotate(-12deg) scale(1.08); }
    16%      { transform: rotate(9deg) scale(1.05); }
    24%      { transform: rotate(-7deg) scale(1.03); }
    32%      { transform: rotate(4deg) scale(1.01); }
    40%      { transform: rotate(-2deg) scale(1); }
    48%      { transform: rotate(0deg) scale(1); }
}

.hint-text {
    font-size: 14px;
    font-weight: 400;
    color: #a8193e;
    line-height: 1.4;
    letter-spacing: -0.1px;
    position: relative;
    display: inline-block;
    overflow: hidden;
}

.hint-text::after {
    content: '';
    position: absolute;
    top: 0;
    left: -60%;
    width: 60%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(234, 34, 97, 0.03) 15%,
        rgba(234, 34, 97, 0.1) 35%,
        rgba(234, 34, 97, 0.18) 50%,
        rgba(234, 34, 97, 0.1) 65%,
        rgba(234, 34, 97, 0.03) 85%,
        transparent 100%
    );
    pointer-events: none;
    animation: hint-text-shimmer 3s ease-in-out infinite;
}

@keyframes hint-text-shimmer {
    0%   { left: -60%; }
    55%  { left: 110%; }
    100% { left: 110%; }
}

/* ============================================================
   REGION NOTE — 投放区域提示卡片（含动效）
   ============================================================ */
.region-note {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 10px 16px;
    background: #f4f2ff;
    border: 1px solid rgba(83, 58, 253, 0.1);
    border-radius: 12px;
    animation: region-note-enter 0.4s cubic-bezier(0.32, 0.72, 0, 1) both;
}

@keyframes region-note-enter {
    from {
        opacity: 0;
        transform: translateX(-12px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.region-note__icon {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: rgba(83, 58, 253, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    animation: region-pin-bounce 2.2s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
}

@keyframes region-pin-bounce {
    0%, 100% { transform: translateY(0); }
    15%      { transform: translateY(-5px); }
    30%      { transform: translateY(0); }
    45%      { transform: translateY(-2px); }
    60%      { transform: translateY(0); }
}

.region-note__text {
    font-size: 14px;
    font-weight: 400;
    color: #2d2a6e;
    line-height: 1.4;
    letter-spacing: -0.1px;
    position: relative;
    display: inline-block;
    overflow: hidden;
}

.region-note__text strong {
    font-weight: 600;
    color: #533afd;
}

.region-note__text::after {
    content: '';
    position: absolute;
    top: 0;
    left: -60%;
    width: 60%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(83, 58, 253, 0.03) 15%,
        rgba(83, 58, 253, 0.12) 35%,
        rgba(83, 58, 253, 0.22) 50%,
        rgba(83, 58, 253, 0.12) 65%,
        rgba(83, 58, 253, 0.03) 85%,
        transparent 100%
    );
    pointer-events: none;
    animation: region-text-shimmer 2.8s ease-in-out infinite;
}

@keyframes region-text-shimmer {
    0%   { left: -60%; }
    55%  { left: 110%; }
    100% { left: 110%; }
}

/* ============================================================
   ERROR BAR — 动效错误条
   ============================================================ */
.error-bar {
    margin-top: 14px;
    padding: 12px 16px;
    background: #fff;
    border: 1.5px dashed rgba(234, 34, 97, 0.3);
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    animation: error-slide-in 0.35s cubic-bezier(0.32, 0.72, 0, 1) both;
}

@keyframes error-slide-in {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.error-bar__badge {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(234, 34, 97, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    animation: error-badge-pulse 2s ease-in-out infinite;
}

@keyframes error-badge-pulse {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.65; }
}

.error-bar__text {
    font-size: 14px;
    font-weight: 400;
    color: #c4294e;
    line-height: 1.45;
    letter-spacing: -0.1px;
}

/* ============================================================
   BUTTON — button-primary-pill
   ============================================================ */
.button-group {
    margin-top: 16px;
    display: flex;
    justify-content: center;
}

.btn-primary-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 48px;
    background: linear-gradient(135deg, #4361ee 0%, #3a56d4 100%);
    color: #ffffff;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.0;
    letter-spacing: 0;
    font-feature-settings: "ss01";
    border: none;
    border-radius: 12px;
    padding: 14px 24px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(67, 97, 238, 0.35), 0 2px 6px rgba(67, 97, 238, 0.2),
        inset 0 1px 0 rgba(255,255,255,0.18);
    transition: all 0.2s ease;
}
.btn-primary-pill:active {
    transform: translateY(1px);
    background: linear-gradient(135deg, #3a56d4 0%, #2e44b0 100%);
    box-shadow: 0 1px 4px rgba(67, 97, 238, 0.25);
}

/* ============================================================
   RESULT CARD
   ============================================================ */
.result-card {
    box-sizing: border-box;
    width: 100%;
    background: linear-gradient(145deg, #ffffff 0%, #f8f7ff 100%);
    border: 1px solid rgba(83, 58, 253, 0.1);
    border-radius: 12px;
    padding: 20px;
    margin-top: 12px;
    box-shadow: 0 2px 12px rgba(83, 58, 253, 0.06), 0 1px 4px rgba(83, 58, 253, 0.03);
}

.result-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.result-label {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.04em;
    color: #64748d;
    text-transform: uppercase;
}

.result-tag {
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.1px;
    line-height: 1.15;
    text-transform: uppercase;
    color: #4434d4;
    background: #b9b9f9;
    border-radius: 9999px;
    padding: 4px 8px;
}

.result-price-row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 12px;
}

.result-original {
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.42px;
    font-feature-settings: "tnum";
    color: #64748d;
    text-decoration: line-through;
}

.result-final {
    font-size: 32px;
    font-weight: 400;
    letter-spacing: -0.64px;
    line-height: 1.1;
    font-feature-settings: "tnum";
    background: linear-gradient(135deg, #533afd 0%, #4434d4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.result-card {
    cursor: pointer;
    transition: transform 0.2s cubic-bezier(0.32, 0.72, 0, 1), box-shadow 0.2s ease;
}

.result-card:active {
    transform: scale(0.985);
    box-shadow: 0 1px 6px rgba(83, 58, 253, 0.05);
}

.result-card--loading {
    pointer-events: none;
    opacity: 0.6;
}

.result-card--limited {
    cursor: default;
}

.result-card--limited:active {
    transform: none;
    box-shadow: 0 2px 12px rgba(83, 58, 253, 0.06), 0 1px 4px rgba(83, 58, 253, 0.03);
}

.result-footer {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid #e3e8ee;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.result-footer-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 18px;
    border-radius: 9999px;
    background: transparent;
    border: 1.5px solid #533afd;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: none;
}

.result-card:active .result-footer-link {
    background: rgba(83, 58, 253, 0.06);
    border-color: #4434d4;
    transform: translateX(2px);
}

.result-footer-text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    font-feature-settings: "ss01";
    color: #533afd;
}

.result-footer-arrow {
    font-size: 15px;
    color: #533afd;
    transition: transform 0.25s ease;
    animation: arrow-nudge 2s ease-in-out infinite;
}

.result-footer-tip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0 auto;
    padding: 8px 14px;
    border-radius: 8px;
    background: #fff4f6;
    border: 1px solid rgba(234, 34, 97, 0.12);
}

.result-footer-tip__text {
    font-size: 13px;
    font-weight: 400;
    color: #a8193e;
    line-height: 1.4;
    letter-spacing: -0.1px;
}

@keyframes arrow-nudge {
    0%, 100% { transform: translateX(0); }
    50%      { transform: translateX(5px); }
}

.result-card:active .result-footer-arrow {
    animation: none;
    transform: translateX(6px);
}

/* ============================================================
   POPUP / PICKER OVERRIDES
   ============================================================ */
.category-search-box {
    padding: 8px 16px;
    background: #f6f9fc;
}

.my-quotation /deep/ .van-picker__confirm {
    color: #533afd;
}

.my-quotation /deep/ .van-picker__cancel {
    color: #64748d;
}

.my-quotation /deep/ .van-picker .van-hairline--top-bottom::after {
    border-color: #e3e8ee;
}

.my-quotation /deep/ .van-popup {
    border-radius: 16px 16px 0 0;
}

/* ============================================================
   LOADING
   ============================================================ */
.my-quotation /deep/ .van-loading {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ============================================================
   DIALOG — verification code
   ============================================================ */
.my-quotation /deep/ .van-dialog {
    overflow: visible;
    top: 65%;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
}

.my-quotation /deep/ .van-dialog .logo-img {
    position: absolute;
    top: -220px;
    z-index: 2105;
    width: 320px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.my-quotation /deep/ .van-dialog .logo-title {
    font-family: Inter, "SF Pro Display", system-ui, sans-serif;
    font-size: 26px;
    font-weight: 300;
    letter-spacing: -0.26px;
    line-height: 1.12;
    color: #1c1e54;
    text-shadow: -1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;
}

/* ============================================================
   OVERLAY
   ============================================================ */
.my-quotation /deep/ .van-overlay {
    background-color: rgba(28,30,84,0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    width: 100%;
    height: 100vh;
}

/* Dialog confirm button */
.my-quotation /deep/ .van-goods-action-button--danger {
    background: #533afd;
}

/* van-button primary override */
.my-quotation /deep/ .van-button--primary {
    background: #533afd;
    border-color: #533afd;
}

/* van-button info override */
.my-quotation /deep/ .van-button--info {
    background: #533afd;
    border-color: #533afd;
}

/* ============================================================
   RESPONSIVE
   ============================================================ */
@media screen and (min-width: 768px) {
    .mesh-hero {
        padding: 64px 32px 64px;
    }
    .hero-title {
        font-size: 32px;
        letter-spacing: -0.64px;
    }
    .quotation-content {
        padding: 24px;
        margin: -32px auto 0;
    }
    /* 提示区与表单卡片之间拉开间距 */
    .hint-line,
    .region-note {
        margin-top: 24px;
        margin-bottom: 28px;
    }
    /* 按钮与下方结果/错误区之间拉开间距 */
    .button-group {
        margin-bottom: 24px;
    }
    .error-bar,
    .result-card {
        margin-top: 24px;
    }
    .btn-primary-pill {
        max-width: 320px;
    }
    .result-card {
        padding: 28px;
    }
}
</style>
